import React, { useEffect, useRef } from "react";
import { useNewCheckoutContext } from "../../context/checkout-context-v2";
import { groupBy } from "../../utils/custom-functions"
import Product from "../product/product";
import { groupByOrigin } from "../../utils/custom-functions";
import { arrayOfOrigins } from "../../utils/informations";

import './modal-products.scss';

const ModalProduct = ({ setOpenModal, openModal, originProduct}) => {

    const { groupedByOriginsProducts, hireRewardQuestions: {
        firstQuestion,
        secondQuestion,
        thirdQuestion,
    } } = useNewCheckoutContext();

    const modalContainer = useRef();
    let results = [];
    let products = [];
    let sortedProducts = {};

    useEffect(() => {
        if (openModal) {
            document.body.style.overflow = "hidden";
        } else if (!openModal) {

            document.body.style.overflow = "unset";
        }
    }, [openModal]);

    useEffect(() => {

        const handleMouseDown = (e) => {

            if(!modalContainer.current.contains(e.target)){
                setOpenModal(false);
            }
        }

        document.addEventListener("mousedown", handleMouseDown);

        return () => {
            document.removeEventListener("mousedown", handleMouseDown);
        };
    });

    useEffect(() => {

        const handleKeyDown = (e) => {

            if(e.key === "Escape"){
                setOpenModal(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    });

    if (typeof window !== "undefined" && window.sessionStorage.getItem("products")) {
        products = JSON.parse(sessionStorage.getItem("products")).products;
    }

    // if user click on 'Get A Quote' btn from secondary-pages (show modal)


    const removeUnknownOrigin = products ? products.filter((item) => arrayOfOrigins.indexOf(item.Origin) !== -1) : []
    let groupedCopy = {};

    if(removeUnknownOrigin){

        groupedCopy = groupByOrigin(removeUnknownOrigin)
    }


    if (Object.keys(groupedCopy).length) {


        try {
            if (secondQuestion === false && thirdQuestion === true) {
                groupedCopy.gap = groupedCopy.gap.filter((item) => item.ProducGroupTitle.includes("Combination Shortfall Insurance"))


            }
            if (secondQuestion === true && thirdQuestion === false) {
                groupedCopy.gap = groupedCopy.gap.filter((item) => item.ProducGroupTitle.match(/Contract Hire (and|&|And) Leasing Gap+/g)
                )


            }
            if (secondQuestion === true && thirdQuestion === true) {
                groupedCopy.gap = groupedCopy.gap.filter((item) => item.ProducGroupTitle.includes("Combined GAP and RTI"))


            }
        } catch (error) {

        }

        if('gap' in groupedCopy && Object.keys(groupedCopy['gap']).length){
            sortedProducts['gap'] = groupedCopy['gap']
        }
        if('mbi' in groupedCopy && Object.keys(groupedCopy['mbi']).length){
            sortedProducts['mbi'] = groupedCopy['mbi']
        }
        if('cosmetic' in groupedCopy && Object.keys(groupedCopy['cosmetic']).length){
            sortedProducts['cosmetic'] = groupedCopy['cosmetic']
        }
        if('alloy' in groupedCopy && Object.keys(groupedCopy['alloy']).length){
            sortedProducts['alloy'] = groupedCopy['alloy']
        }
        if('excess' in groupedCopy && Object.keys(groupedCopy['excess']).length){
            sortedProducts['excess'] = groupedCopy['excess']
        }
        if('tyre' in groupedCopy && Object.keys(groupedCopy['tyre']).length){
            sortedProducts['tyre'] = groupedCopy['tyre']
        }
        

        const cardsValues = Object.values(sortedProducts)

        let grouped = []
        cardsValues?.map((item) => {

            let groupedItem = groupBy("ProducGroupTitle", item)
            grouped.push(groupedItem)
        })

        results = grouped?.filter(element => {
            if (Object.keys(element).length !== 0) {
                return true;
            }

            return false;
        });

    }


    return (

        <div id="myModal" className={`modal-product ${openModal ? 'show-modal' : 'hidden-modal'}`}>
            <div className="modal-content-product" ref={modalContainer}>
                <span className="close" onClick={() => setOpenModal(false)}>&times;</span>
                {
                    results.length && Object.keys(results[0]).length !== 0 ? (
                        <div className="product-modal">
                            {
                                results.map((item, index) => {

                            
                                    for (let key in item) {
                                        item[key] = groupBy('claim_limit', item[key])
                                    }

                                    let origin = Object.values(Object.values(Object.values(item)[0])[0])[0].Origin;
                                    if(origin === originProduct || ((origin === "Return to Invoice" || origin === "Finance Gap") && originProduct === "Gap")){
                                        return <Product props={item} origin={origin} radioName={index} key={index} displayOnModal={true}/>

                                    }
                                    


                                })
                            }
                        </div>
                    ) : ""
                }
            </div>

        </div>
    )


}

export default ModalProduct;